import {
  ActionButton,
  Loading,
  useShowNotification
} from '@elotech/components';
import { alert } from 'common/components';
import { useLoading } from 'common/hooks';
import { useSelector } from 'react-redux';
import { ArquivoAssinaturaService } from 'service';
import { getConfigSelector } from 'state';

const AssinaturaActionButton = ({ assinatura, onUpdateFile }) => {
  const config = useSelector(state => getConfigSelector(state));
  const showNotification = useShowNotification();
  const [loading, setLoading] = useLoading();

  const validaPermissaoAssinaturaEletronica = (handleClick, param) => {
    if (config.possuiAssinaturaContratada || config.possuiAssinaturaCortesia) {
      handleClick(param);
    } else {
      return showNotification({
        level: 'error',
        message:
          'Rotina indisponível. Entrar em contato com a Elotech no Departamento Comercial'
      });
    }
  };

  const validaPermissaoAssinaturaDigital = (handleClick, param) => {
    if (config.possuiAssinaturaContratada) {
      handleClick(param);
    } else {
      return showNotification({
        level: 'error',
        message:
          'Rotina indisponível. Entrar em contato com a Elotech no Departamento Comercial'
      });
    }
  };

  const onRejeitarAssinatura = () => {
    alert({
      type: 'warning',
      title: 'Rejeitar',
      input: 'textarea',
      showCancelButton: true,
      cancelButtonColor: '#c7382d',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Rejeitar',
      onConfirm: motivo =>
        ArquivoAssinaturaService.rejeitarAssinatura(
          assinatura.identificador,
          motivo
        ).then(() => onUpdateFile()),
      text: 'Deseja mesmo rejeitar a assinatura?',
      inputPlaceholder: 'Informe o motivo da rejeição',
      inputValidator: value => {
        return new Promise(resolve => {
          if (!value) {
            return resolve('Informe o motivo de estar recusando a assinatura.');
          }
          resolve(false);
        });
      }
    });
  };

  const onAssinarDigital = () => {
    if (assinatura?.id) {
      ArquivoAssinaturaService.runSigner(
        assinatura.id,
        assinatura.urlS3,
        config.tenant
      );
    } else {
      ArquivoAssinaturaService.solicitarAssinaturaDigital(
        assinatura.identificador
      ).then(({ data }) => {
        ArquivoAssinaturaService.runSigner(
          data.id,
          assinatura.urlS3,
          config.tenant
        );
      });
    }
  };

  const onAssinarEletronicaClick = () => {
    alert({
      title: 'Autenticação',
      input: 'password',
      type: 'question',
      text: 'Para assinar o documento é necessário realizar a autenticação.',
      inputPlaceholder: 'Digite sua senha',
      showCancelButton: true,
      confirmButtonText: 'Autenticar',
      cancelButtonText: 'Cancelar',
      onConfirm: async senha => {
        await setLoading(
          ArquivoAssinaturaService.assinar({
            identificador: assinatura.identificador,
            senha
          }).then(() => onUpdateFile())
        );
      },
      inputValidator: value => {
        return new Promise(resolve => {
          if (value) {
            resolve();
          } else {
            resolve('Digite a senha.');
          }
        });
      }
    });
  };

  return (
    <>
      <Loading loading={loading} />
      <ActionButton
        icon="signature"
        links={[
          {
            label: 'Assinatura Eletrônica',
            onClick: () =>
              validaPermissaoAssinaturaEletronica(onAssinarEletronicaClick)
          },
          {
            label: 'Assinatura Digital',
            onClick: () => validaPermissaoAssinaturaDigital(onAssinarDigital)
          },
          {
            label: 'Rejeitar',
            onClick: () => onRejeitarAssinatura()
          }
        ]}
      />
    </>
  );
};

export default AssinaturaActionButton;
